<template>
    <div v-if="item" class="billa-app--popup">
        <div class="billa-app--popup--box">
            <div class="billa-app--popup--box--header">
                <div class="billa-app--popup--box--header--col">
                    {{ item.title }}
                </div>

                <div class="billa-app--popup--box--header--col">
                    <span @click="$emit('closePopup')">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" fill="currentColor" />
                        </svg>
                    </span>
                </div>
            </div>

            <div class="billa-app--popup--box--body">
                <PhotoBox v-if="item" :options="options" :item="item" @updateVotes="item.votes = $event" />
            </div>

            <div class="billa-app--popup--box--footer">
                <div class="billa-app-buttons billa-app-buttons-center">
                    <div class="billa-app-button billa-app-button-green" @click="$emit('closePopup')">
                        Vrátiť sa na stránku
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PhotoBox from './PhotoBox'

    export default {
        components: {
			PhotoBox
		},
        props: {
			options: {
				type: Object
			},
            slug: {
                type: String
            }
		},
        data() {
            return {
                item: null
            }
        },
        created() {
            this.loadPhoto()
        },
        methods: {
            loadPhoto() {
                axios.get(`${this.options.app_url}/api/resources/${this.slug}`)
				.then( response => { this.item = response.data.item })
				.catch( errors => { return alert( errors.response.data.message )})
            }
        },
    }
</script>